import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	rootTitle: {
		id: 'software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate',
		defaultMessage: 'Quickstart',
		description: 'Initial title of the Quickstart',
	},
});
